import React from 'react';

const SuforiaTheme = {
  headerLogo: {
    src: '/themes/theme/suforia/suforia-white-text.png',
    alt: 'Suforia influencers',
  },
  darkLogo: {
    src: '/themes/theme/suforia/suforia-dark-text.png',
    alt: 'Suforia influencers',
  },
  headerStyle: {
    backgroundColor: '#211e1e',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: true,
  title: 'SUFORIA',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="100" src="/themes/theme/suforia/suforia-dark-text.png" alt="Suforia Influencers" />
    </div>
  ),
  shareSite: 'https://share.suforia.com',
  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9',
};

export default SuforiaTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/suforia.js
 **/